<template>
    <SuperAdminLayout v-if="isAuthenticated" />
    <SuperAdminLogin v-else />
</template>

<script>
import { ref } from 'vue';
import SuperAdminLayout from './SuperAdminLayout.vue';
import SuperAdminLogin from './SuperAdminLogin.vue';

export default {
    name: 'HomeEntry',
    components: {
        SuperAdminLayout,
        SuperAdminLogin
    },
    setup() {
        const isAuthenticated = ref(!!localStorage.getItem('super_admin_token'));
        return { isAuthenticated };
    }
}
</script>
